import { createContext, useContext, type ReactNode } from 'react';
import { useCoachPanel } from '@/hooks/useCoachPanel';

interface CoachPanelContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const CoachPanelContext = createContext<CoachPanelContextValue | null>(null);

export function CoachPanelProvider({ children }: { children: ReactNode }) {
  const panel = useCoachPanel();

  return (
    <CoachPanelContext.Provider
      value={{
        isOpen: panel.isOpen,
        open: panel.open,
        close: panel.close,
        toggle: panel.toggle,
      }}
    >
      {children}
    </CoachPanelContext.Provider>
  );
}

export function useCoachPanelContext() {
  const ctx = useContext(CoachPanelContext);
  if (!ctx) {
    throw new Error('useCoachPanelContext must be used within CoachPanelProvider');
  }
  return ctx;
}
